import React from "react";
import { getDiffInMinutesWithTerminalTime } from '../../../../utils/utils';
import PickupNumberRefreshed from "./PickupNumberCell";
import { PICKUP_STATUS } from '../../../constants';
import { getPickupStatus } from "../../../utils/pickupStatusTypeIcon";

class PickupNumber extends React.Component {
  constructor(props) {
    super(props);
    const pickupStatus = this.getCurrentPickupStatus(props)
    this.state = {
      timeDiff: this.getTimeDiff(pickupStatus),
      pickupStatus,
      timeToCloseInMins: this.getTimeToCloseInMins(props),
      pickupNumber: props.value
    };
  }

  getTimeDiff = (pickupStatus) => {
    return pickupStatus === PICKUP_STATUS.newPickup ? getDiffInMinutesWithTerminalTime(
        this.props.data.createdDateTime,
        this.props.context.terminalOffset
      ) : null
  }

  getTimeToCloseInMins = (props) => {
    if(props.isGroupHeader) {
      return props.context.getGroupClosingSoonPickupTime?.(props.data.pickupNumberIdList);
    }
    return props.context.getClosingSoonPickupTime(props.data.pickupId)
  }

  getCurrentPickupStatus = (props) => {
    return getPickupStatus({pickup:props.data, terminalOffset: props.context.terminalOffset, newPickupDuration: props.context.newPickupDuration})
  }

  refresh = (props) => {
    const pickupStatus = this.getCurrentPickupStatus(props)
    this.setState({
      timeDiff: this.getTimeDiff(pickupStatus),
      pickupStatus: pickupStatus,
      timeToCloseInMins : this.getTimeToCloseInMins(props),
      pickupNumber: props.value
    });
    return true;
  };

  componentDidUpdate(prevProps) {
    // Check if pickup data has changed and refresh accordingly
    if (prevProps.data !== this.props.data || 
        prevProps.value !== this.props.value ||
        prevProps.context !== this.props.context) {
      this.refresh(this.props);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    /* Adding this condition here to show new pickup icon for 10 min , 
    after 10 min it will convert to unassign pickup icon then we will rerender component based on props */
    return (
      this.state.pickupStatus !== nextState.pickupStatus ||
      this.state.timeDiff !== nextState.timeDiff ||
      (nextState.timeToCloseInMins <=
        this.props.context.closingSoonLimitConfig.closingSoonWarningTimeLimit &&
        this.state.timeToCloseInMins !== nextState.timeToCloseInMins) ||
        this.state.pickupNumber !== nextState.pickupNumber ||
        nextProps.data !== this.props.data ||
        nextProps.value !== this.props.value ||
        nextProps.context !== this.props.context
    );
  }

  render() {
    return (
      <PickupNumberRefreshed
        pickupStatus={this.state.pickupStatus}
        value={this.state.pickupNumber}
        timeDiff={this.state.timeDiff}
        timeToCloseInMins={this.state.timeToCloseInMins}
        closingSoonLimitConfig={this.props.context.closingSoonLimitConfig}
      />
    );
  }
}

export default PickupNumber;
